/**
 * Query Key factory for all lab queries.
 *
 * @module Laboratory
 */

import { Pagination } from "@customTypes/index";


export const labQKeys = {
  all: () => ["labs"] as const,

  allWithFilters: (filters?: {
    pagination?: Partial<Pagination>;
    search?: string;
    status?: string;
    fields?: string[];
    userId?: string;
  }) => [...labQKeys.all(), { ...filters }] as const,

  patients: () => [...labQKeys.all(), "patient"] as const,

  patient: (patientId: string) => [...labQKeys.patients(), patientId] as const,

  patientWithFilters: (
    patientId: string,
    filters: {
      withFilesOnly?: boolean;
      fastConsultationOnly?: boolean;
      consultationId?: string;
      pagination?: Partial<Pagination>;
      search?: string;
      status?: string;
      category?: string;
    }
  ) => [...labQKeys.patient(patientId), { ...filters }] as const,
};
